import { createCookie } from '.'

const handleNewAuthFatalError = (err) => {
  console.error('Fatal error', err)
  return 'newAuth'
}

export const loginOnNewAuth = async (idToken, accessToken) => {
  var myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

  var urlencoded = new URLSearchParams()
  urlencoded.append('x-auth-user', idToken)
  urlencoded.append('x-session-token', accessToken)

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
    redirect: 'follow',
  }

  let resfetch = await fetch(
    process.env.REACT_APP_REGISTRATION_URL + '/anagrafica-cliente',
    requestOptions
  )
  let resjson = await resfetch
    .json()
    .then((result) => {
      console.log('response S08 ->')
      console.log(JSON.stringify(result))
      if (result && result.tipo_cliente && result.tipo_cliente === 'PROSPECT') {
        window.isUtenteProspect = true
      }

      if (result && result.tipo_cliente) {
        createCookie(
          'a2a_user_type',
          btoa(result.tipo_cliente),
          2 / 24,
          undefined,
          '.a2a.it',
          [{ SameSite: 'None' }, { secure: null }]
        )
      }

      // CRQA2A-1404: Set cookie sn_credit_check_sale_vas
      if (result && result.sn_credit_check_sale_vas !== undefined) {
        createCookie(
          'sn_credit_check_sale_vas',
          result.sn_credit_check_sale_vas === true ? 'true' : 'false',
          1,
          undefined,
          '.a2a.it',
          [{ SameSite: 'None' }, { secure: null }]
        )
      }

      return 'newAuth'
    })
    .catch(handleNewAuthFatalError)

  return resjson
}
